<template>
    <div
        class="hello"
        ref="pageDiv"
        @mousemove="onmousemove($event)"
        @touchmove="onmousemove($event)"
        @mouseup="onmouseup($event)"
        @touchend="onmouseup($event)"
    >
        <div
            v-if="activityData && !option.name"
            class="ActivitySyn"
            @click="activitySkip"
            style="position: relative"
        >
            <img src="../../assets/activityUrl/activityBg.png" class="activity-image" />
            <span class="activity-name">{{ activityData.name }}</span>
            <img src="../../assets/activityUrl/path.png" class="activity-path" />

            <!-- <van-sticky :offset-top="10" style="position: relative;left: 0;top: -60px;z-index: 99;">
                <van-button type="primary" @click.stop="orderEntry">申卡订单</van-button>
            </van-sticky> -->
        </div>
        <!-- 脱拽机器人 -->
        <div
            class="action-mgr active"
            ref="actionMgr"
            @click.stop="orderEntry"
            @mousedown="onmousedown($event)"
            @touchstart="onmousedown($event)"
        >
            <img src="../../assets/activityUrl/moveIcon.png" alt="" />
        </div>
        <div class="horizonal-tab">
            <van-tabs v-model="current" @click="onClickItem">
                <van-tab
                    :title="value.name"
                    :name="value.id"
                    v-for="(value, index) in items"
                    :key="index"
                ></van-tab>
            </van-tabs>
        </div>
        <div class="inesli" v-if="ceditCardlist.length > 0">
            <div
                v-for="(item, index) in ceditCardlist"
                class="conten"
                :key="index"
                @click="extrnsion(item.creditId, item)"
            >
                <div class="conteli">
                    <div
                        :class="
                            item.status == 1
                                ? 'inescole'
                                : item.status == 2
                                ? 'inescoleblue'
                                : item.status == 4
                                ? 'inescolebluet'
                                : 'inescolexin'
                        "
                    >
                        {{
                            item.status == 1
                                ? '强烈推荐'
                                : item.status == 2
                                ? '热门'
                                : item.status == 4
                                ? '通过率高'
                                : '最新'
                        }}
                    </div>
                </div>
                <div class="inesimg">
                    <img :src="item.icon" />
                </div>
                <!-- bug#1771: 资源名称分行显示 -->
                <div
                    class="spname"
                    :style="{ '--bar-width': boxSize + 'px', height: '50px' }"
                    :class="
                        (emSize * (item.name.match(/[^\u4e00-\u9fa5]/g) || []).length) / 1.8 +
                            emSize * (item.name.match(/[\u4e00-\u9fa5]/g) || []).length >=
                        boxSize
                            ? ''
                            : ''
                    "
                >
                    {{ item.name.toString() }}
                </div>
                <!-- spname :class 1(em2px) *不包括中文的字符宽度（非中文字符0.5em） + 1(em2px) 中文字符的宽度  = name的宽度 > 盒子的宽度 ？ 添加动画 ： ‘’-->
                <div class="uni-flex ineslable" :class="{ center: item.labels.length < 2 }">
                    <div
                        :class="index == 1 ? 'lableis' : 'lablei'"
                        v-for="(item, index) in item.labels"
                        :key="index"
                    >
                        {{ item }}
                    </div>
                </div>
                <div v-if="item.code != 'CMBC100EHPQ'" class="lospen">{{ item.remarks }}</div>
                <div v-else style="color: orange" class="lospen">{{ item.remarks }}</div>

                <div class="uni-flex insetomm" v-if="!option.name">
                    <!-- 	<view class="tommle">奖</view> -->
                    <img
                        :src="`http://app.yhbzf.com:7777/group1/M00/00/04/rB3g-WGV6dmAWYi0AAAOC8fUh7s423.png`"
                    />
                    <div v-if="item.code != 'CMBC100EHPQ'" class="miey">
                        ￥{{ item.commission }}
                    </div>
                    <div v-else class="miey" style="color: yellow">￥{{ item.commission }}</div>
                </div>
                <!-- <view class="liji">立即推广</view> -->
            </div>
        </div>
        <div class="pagesli" v-else>
            <img class="pagesli" src="../../assets/activityUrl/nodata.jpg" mode="widthFix" />
        </div>
    </div>
</template>
<script>
import { formatDateTime } from '../../utils/core.js';
import {
    getCreditList,
    getCreditTypeList,
    getDataList,
    getActivityEntry,
    getCreditListH5,
    getJumpLinkUrl,
} from '@/api/index';
import { mapMutations, mapState } from 'vuex';

export default {
    data() {
        return {
            emSize: 0, // spname 一个字体的宽度
            boxSize: 0, // 一个 conten 的宽度
            current: 0, //列表切换
            currentIndex: 0, //列表索引
            items: [], //资源列表
            swiperheight: 500,
            ceditCardlist: [], //信用卡列表
            typeId: 0, //资源ID
            // url: 'http://app.yhbzf.com:7777/group1/M00/00/04/rB3g-WGV6dmAWYi0AAAOC8fUh7s423.png'
            activityData: {},
            activity: null,
            currentActivityId: null, // 第一条活动
            mousedownState: false, //鼠标默认抬起
            iX: 0, //鼠标坐标 与 拖拽按钮 间距 x
            iY: 0, //鼠标坐标 与 拖拽按钮 间距 y
            // app端跳转参数
            option: {
                name: '', //姓名
                phone: '', // 手机号
                idCard: '', // 身份证
                token: '', // token
                merchantType: '', // 商户来源类型
            },
        };
    },
    computed: {
        ...mapState(['merchantCardInfo']),
    },
    created() {
        // 获取来源参数，如果没有则默认不加载
        var url = window.location.href; //获取地址栏路径
        var temp1 = url.split('?'); //对url地址进行分割
        var pram = temp1[1];
        var keyValue = pram && pram.split('&');
        var obj = {};
        if (keyValue) {
            for (var i = 0; i < keyValue.length; i++) {
                //循环分割挂过后的地址
                var item = keyValue[i].split('=');
                var key = item[0];
                var value = item[1];
                obj[key] = value;
            }
            // name 是汉字，token有特殊符号 浏览器会自动转码，所以需要解码
            this.option = {
                name: decodeURI(obj.name),
                phone: obj.phone,
                idCard: obj.idCard,
                token: decodeURIComponent(obj.token),
                merchantType: obj.merchantType,
                userSource: obj.userSource,
                merchantId: obj.merchantId,
            };
        }
        // 将token存入vuex
        this.saveToken(this.option.token);
        // 将商户信息存入vuex
        this.setMerchantCardInfo(obj);
        // 获取资源列表
        getCreditTypeList(this.$store.getters.getToken).then(res => {
            if (res.code == 200) {
                this.items = res.data.filter(value => value.id != 6); // 过滤信贷

                // if (option?.typeId) {
                //     let index = this.items.findIndex(item => item.id == option.typeId);

                //     if (index !== -1) this.onClickItem({
                //         currentIndex: index
                //     })
                // }
                // 获取银行卡列表
                if (!this.option.token) {
                    this.getdata();
                    this.getActivityData();
                } else {
                    this.getMerchantList(this.option.token);
                }
            }
        });
    },
    // 第二次进入页面默认从缓存中拿数据
    methods: {
        ...mapMutations(['saveToken', 'setMerchantCardInfo']),
        formatDateTime,
        // 获取商户列表
        async getMerchantList() {
            const res = await getCreditListH5(this.typeId, this.$store.getters.getToken);
            if (res.code == 200) {
                this.ceditCardlist = res.data.rows.filter(item => item.type == 0);

                if (this.typeId == 7) {
                    if (res.data.rows.length > 0) {
                        this.activity = res.data.extraData;
                    } else {
                        this.activity = {
                            noDataImg: res.data.extraData,
                        };
                    }
                } else {
                    this.activity = res.data.extraData;
                }
            }
        },
        // 信用卡活动跳转
        activitySkip() {
            if (this.currentActivityId) {
                this.$router.push({
                    path: '/activityDetail',
                    query: {
                        id: this.currentActivityId,
                        dataType: 0,
                    },
                });
            } else {
                this.$router.push({
                    path: '/activity',
                    query: {
                        enrce: this.activityData.id,
                        dataType: 0,
                    },
                });
            }
        },
        getdata() {
            let data = {
                typeId: this.typeId,
            };
            getCreditList(data.typeId, this.$store.getters.getToken).then(res => {
                if (res.code == 200) {
                    this.ceditCardlist = res.data.rows.filter(item => item.type == 0);

                    if (this.typeId == 7) {
                        if (res.data.rows.length > 0) {
                            this.activity = res.data.extraData;
                        } else {
                            this.activity = {
                                noDataImg: res.data.extraData,
                            };
                        }
                    } else {
                        this.activity = res.data.extraData;
                    }
                }
            });
        },
        // 活动入口
        getActivityData() {
            let newdata = {
                dataType: 0,
            };
            getActivityEntry(newdata, this.$store.getters.getToken).then(res => {
                if (res.code == 200) {
                    this.activityData = res.data;
                }
            });
            // 数据列表
            getDataList(1, 10, newdata, this.$store.getters.getToken).then(res => {
                if (res.code == 200) {
                    let arr = [];
                    arr = res.data.rows;
                    if (arr.length == 1) {
                        this.currentActivityId = arr[0].id;
                    } else {
                        this.currentActivityId = null;
                    }
                }
            });
        },
        //切换选项卡
        onClickItem(e) {
            if (this.currentIndex == e) {
                return;
            }
            this.currentIndex = e;
            this.typeId = e;
            if (!this.option.token) {
                this.getdata();
            } else {
                this.getMerchantList(this.option.token);
            }
        },
        //申卡订单入口
        orderEntry() {
            this.$router.push({
                path: '/cardapplication',
            });
        },
        // 跳转资源详情
        async extrnsion(creditId) {
            if (!this.option.token) {
                this.$router.push({
                    path: '/extension',
                    query: {
                        creditId: creditId,
                    },
                });
            } else {
                // console.log(item.jumpLink)
                const res = await getJumpLinkUrl(creditId, this.option.token);
                let url = '/userInformation?';
                // 将res.data.jumpLink?后面的参数截取下来拼接到url后面
                let params = res.data.jumpLink.split('?')[1] || '';
                var keyValue = params && params.split('&');
                var obj = {};
                if (keyValue) {
                    for (var i = 0; i < keyValue.length; i++) {
                        //循环分割挂过后的地址
                        var item = keyValue[i].split('=');
                        var key = item[0];
                        var value = item[1];
                        obj[key] = value;
                    }
                    // name 是汉字，token有特殊符号 浏览器会自动转码，所以需要解码
                }
                for (let key in obj) {
                    if (key != 'jumpLink') {
                        url += `${key}=${obj[key]}&`;
                    }
                }
                let url1 =
                    url +
                    `name=${res.data.name}&userName=${this.option.name}&phone=${this.option.phone}&idCard=${this.option.idCard}&userSource=${this.option.userSource}&merchantId=${this.option.merchantId}&channelId=${res.data.channelId}&t=${res.data.jumpType}&creditId=${creditId}`;
                    console.log(url1,555555555555555555555555555,res.data.jumpLink,66666666666666666666666666666666666666666666666666666666)
                this.$router.push({
                    path: url1,
                    query: {
                        creditId: creditId,
                    },
                });

                // res.data.jumpLink 拼接上姓名 手机号 身份证 userSource  merchantId
                // 判断有无参数
                // let url
                // if (res.data.jumpLink.indexOf('?') > -1) {
                //   url = res.data.jumpLink + `&userName=${this.option.name}&phone=${this.option.phone}&idCard=${this.option.idCard}&userSource=${this.option.userSource}&merchantId=${this.option.merchantId}&channelId=${res.data.channelId}&t=${res.data.jumpType}&creditId=${creditId}`
                // } else {
                //   url = res.data.jumpLink + `&userName=${this.option.name}&phone=${this.option.phone}&idCard=${this.option.idCard}&userSource=${this.option.userSource}&merchantId=${this.option.merchantId}&channelId=${res.data.channelId}&t=${res.data.jumpType}&creditId=${creditId}`
                // }
                // var u = navigator.userAgent
                // // 判断u是安卓还是ios
                // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
                // if (isAndroid) {
                //   window.open(url)
                // } else {
                //   window.location.href = url
                // }
                // window.open(
                //     `http://192.168.110.86:8080/userInformation?&userName=${this.option.name}&phone=${this.option.phone}&idCard=${this.option.idCard}&userSource=${this.option.userSource}&merchantId=${this.option.merchantId}&channelId=${res.data.channelId}&t=${res.data.jumpType}&creditId=${creditId}`
                // );
            }
        },
        /* 鼠标按下事件 */
        onmousedown(event) {
            /* 此处判断  pc 或 移动端 得到 event 事件 */
            var touch;
            if (event.touches) {
                touch = event.touches[0];
            } else {
                touch = event;
            }
            // 鼠标点击 面向页面 的 x坐标 y坐标
            let { clientX, clientY } = touch;
            // 鼠标x坐标 - 拖拽按钮x坐标  得到鼠标 距离 拖拽按钮 的间距
            this.iX = clientX - this.$refs.actionMgr.offsetLeft;
            // 鼠标y坐标 - 拖拽按钮y坐标  得到鼠标 距离 拖拽按钮 的间距
            this.iY = clientY - this.$refs.actionMgr.offsetTop;
            // 设置当前 状态为 鼠标按下
            this.mousedownState = true;
        },
        /* 鼠标移动事件 */
        onmousemove(event) {
            //鼠标按下 切移动中
            if (this.mousedownState) {
                /* 此处判断  pc 或 移动端 得到 event 事件 */
                var touch;
                if (event.touches) {
                    touch = event.touches[0];
                } else {
                    touch = event;
                }
                // 鼠标移动时 面向页面 的 x坐标 y坐标
                let { clientX, clientY } = touch;
                //当前页面全局容器 dom 元素  获取容器 宽高
                let { clientHeight: pageDivY, clientWidth: pageDivX } = this.$refs.pageDiv;
                /* 鼠标坐标 - 鼠标与拖拽按钮的 间距坐标  得到 拖拽按钮的 左上角 x轴y轴坐标 */
                let [x, y] = [clientX - this.iX, clientY - this.iY];

                //拖拽按钮 dom 元素  获取 宽高 style 对象
                let {
                    clientHeight: actionMgrY,
                    clientWidth: actionMgrX,
                    style: actionMgrStyle,
                } = this.$refs.actionMgr;
                /* 此处判断 拖拽按钮 如果超出 屏幕宽高 或者 小于  
					   设置 屏幕最大 x=全局容器x y=全局容器y 否则 设置 为 x=0 y=0 
					*/
                if (x > pageDivX - actionMgrX) x = pageDivX - actionMgrX;
                else if (x < 0) x = 0;
                if (y > pageDivY - actionMgrY) y = pageDivY - actionMgrY;
                else if (y < 0) y = 0;
                // 计算后坐标  设置 按钮位置
                actionMgrStyle.left = `${x}px`;
                actionMgrStyle.top = `${y}px`;
                actionMgrStyle.bottom = 'auto';
                actionMgrStyle.right = 'auto';
                //当按下键滑动时， 阻止屏幕滑动事件
                event.preventDefault();
            }
        },
        /* 鼠标抬起事件 */
        onmouseup() {
            // 设置当前状态为鼠标抬起
            this.mousedownState = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.action-mgr img {
    width: 66px;
    height: 69px;
}

.action-mgr {
    z-index: 999;
    position: fixed;
    top: 5.5rem;
    right: 0;
}

.inesli {
    width: 99%;
    margin: auto;
    flex-wrap: wrap;
    display: flex;

    .inesimg {
        width: 100%;
        height: 45px;
        margin-top: 2px;

        img {
            width: 45px !important;
            height: 45px;
            // border-radius: 50%;
        }
    }

    .inescole {
        font-size: 8px;
        background-color: red;
        background-image: linear-gradient(to right, orange, red);
        color: #ffffff;
        // width: 100rpx;
        padding: 2px 6px;
        border-radius: 7.5px;
        margin-top: 2px;
        margin-left: 4px;
        white-space: pre;
    }

    .inescoleblue {
        font-size: 8px;
        background-color: #33c4ff;
        background-image: linear-gradient(to right, #359aff, #33c6ff);
        color: #ffffff;
        // width: 100rpx;
        padding: 2px 6px;
        border-radius: 7.5px;
        margin-top: 2px;
        margin-left: 4px;
    }

    .inescolebluet {
        font-size: 8px;
        background-color: #33c4ff;
        background-image: linear-gradient(to right, orange, #33c6ff);
        color: #ffffff;
        // width: 100rpx;
        padding: 2px 6px;
        border-radius: 7.5px;
        margin-top: 2px;
        margin-left: 4px;
    }

    .inescolexin {
        font-size: 8px;
        background-color: orange;
        background-image: linear-gradient(to right, yellow, orange);
        color: #ffffff;
        // width: 60rpx;
        padding: 2px;
        border-radius: 7.5px;
        margin-top: 2px;
        margin-left: 4px;
    }

    .conten {
        width: 32%;
        // height: 470rpx;
        padding-bottom: 20px;
        text-align: center;
        background-color: #ffffff;
        border-radius: 10px;
        margin-top: 3%;
        margin-left: 1%;
        position: relative;
        overflow: hidden;

        .conteli {
            width: 45%;
            text-align: center;
            margin-bottom: 4px;
        }

        .spname {
            font-weight: bold;
            line-height: 25px;
            letter-spacing: 0.5px;
            margin-top: 10px;
            font-size: 15px;
            display: -webkit-box;
            padding: 0 5px;
            overflow: hidden;
            /* 创建一个弹性容器盒子模型 */
            -webkit-box-orient: vertical;
            /* 设置盒子的排列方向为垂直 */
            -webkit-line-clamp: 2;
            /* 限制在3行内 */
            word-break: break-all;
            /* 允许在单词内换行 */
        }

        .spname-new {
            font-weight: bold;
            line-height: 25px;
            letter-spacing: 0.5px;
            margin-top: 10px;
            font-size: 15px;
        }

        .ineslable {
            display: flex;
            font-size: 9px;
            justify-content: space-between;
            width: 99%;
            margin: auto;
            margin-top: 10px;

            .lablei {
                border: 1px solid red;
                padding: 2.5px;
                color: red;
                width: 43%;
                height: 15px;
                line-height: 15px;
                white-space: pre;
            }

            .lableis {
                border: 1px solid blue;
                padding: 2.5px;
                color: blue;
                width: 43%;
                height: 15px;
                line-height: 15px;
                white-space: pre;
            }

            .lableblue {
                border: 1px solid blue;
                padding: 2.5px;
                color: blue;
                width: 42%;
            }

            &.center {
                justify-content: center;
            }
        }

        .lospen {
            font-size: 10px;
            line-height: 20px;
            width: 96%;
            margin: auto;
            margin-top: 10px;
            height: 40px;
            color: #484848;
            overflow: hidden; //超出文本隐藏
            text-overflow: ellipsis; ///超出部分省略号显示
            display: -webkit-box; //弹性盒模型
            -webkit-box-orient: vertical; //上下垂直
            -webkit-line-clamp: 2; //自定义行数
        }

        .insetomm {
            width: 90%;
            height: 22.5px;
            line-height: 22.5px;
            margin: auto;
            background-color: #fa4f5f;
            border-radius: 25px;
            margin-top: 5%;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: 15px;
                height: 15px;
            }

            // .tommle {
            // 	width: 55rpx;
            // 	height: 55rpx;
            // 	line-height: 55rpx;
            // 	background-color: #fa4f5f;
            // 	color: #FFE126;
            // 	border-radius: 50%;
            // 	border-right: 2rpx solid #FFFFFF;
            // 	padding: 0 5rpx 0 5rpx;
            // }

            .miey {
                color: #ffffff;
                font-size: 11px;
                letter-spacing: 0.5px;
                // font-weight: bold;
                // margin-left: 10rpx;
            }
        }

        .liji {
            line-height: 30px;
            background-color: #cf142b;
            color: #ffffff;
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
            position: absolute;
            bottom: 0;
            width: 100%;
        }
    }
}

.anim {
    white-space: nowrap;
    display: inline-block;
    animation: 5s wordsLoop linear infinite alternate;
}

.wrapper {
    background-size: 100% auto;
    background-repeat: no-repeat;
}

.activity-header {
    text-align: center;

    &-title {
        font-size: 24px;
        text-shadow: 0 2px 0 #9c1717;
        color: #ffffff;
        text-align: center;
        padding: 60px 30px 0;
        line-height: 34px;
        margin-bottom: 14px;
    }

    &-sub {
        color: #ffffff;
        line-height: 19px;
        padding: 2px 16px 4px;
        display: inline-block;
        margin: 0 auto 20px;
        font-size: 14px;
        border-radius: 12.5px;
        border: 1px solid #ffffff;
    }
}

.activity-footer {
    &-title {
        font-size: 24px;
        color: #ffffff;
        text-align: center;
        padding-top: 6px;
        line-height: 34px;
        margin-bottom: 10px;
    }

    &-rule {
        // min-height: 210rpx;
        margin: 20rpx 32rpx;
        background-color: rgba(#ffffff, 0.15);
        border-radius: 6rpx;
        font-size: 26rpx;
        color: #ffffff;
        line-height: 36rpx;
        padding: 24rpx 20rpx;
    }

    &-copyright {
        color: #ffebb6;
        font-size: 28rpx;
        text-align: center;
        margin-bottom: 54rpx;
    }
}

.active-noData {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 156rpx;

    &-img {
        width: 300rpx;
        display: inline-block;
        margin-bottom: 56rpx;
    }

    &-text {
        font-size: 30rpx;
        font-weight: 400;
        color: #999999;
        line-height: 60rpx;
        margin-bottom: 20rpx;
    }

    &-sub {
        font-size: 30rpx;
        font-weight: 400;
        color: #333333;
        line-height: 60rpx;
    }
}

@keyframes wordsLoop {
    from {
        transform: translateX(0);
    }

    to {
        transform: translateX(calc(var(--bar-width) - 100%));
    }
}

.ActivitySyn {
    height: 60px;
    position: relative;
}

.activity-name {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80%;
    text-align: center;
    transform: translate(-50%, -50%);
    font-size: 22px;
    font-family: HarmonyOS_Sans_SC_Black;
    color: #ffffff;
}

.activity-image {
    width: 100%;
    height: 56px;
}

.activity-path {
    width: 6px;
    height: 10px;
    position: absolute;
    top: 50%;
    right: 4%;
    transform: translate(-50%, -50%);
}

.pagesli {
    height: 100vh;
    width: 100vw;
    text-align: center;
    background: #ffffff;
}
</style>
